// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, [121], () => (__webpack_require__("./node_modules/element-closest/element-closest.js")))
__webpack_require__.O(undefined, [121], () => (__webpack_require__("./src/client/polyfill.ts")))
__webpack_require__.O(undefined, [121], () => (__webpack_require__("./src/client/publicPath.ts")))
var __webpack_exports__ = __webpack_require__.O(undefined, [121], () => (__webpack_require__("./src/client.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
